import React from 'react';
import { ArrowRight } from 'lucide-react';
import HeroSlider from '../components/home/HeroSlider';
import PracticeAreaCard from '../components/home/PracticeAreaCard';
import LeadershipCard from '../components/home/LeadershipCard';
import ClientLogo from '../components/home/ClientLogo';
import InquiryForm from '../components/home/InquiryForm';
import CTASection from '../components/home/CTASection';
import SectionTitle from '../components/ui/SectionTitle';
import Button from '../components/ui/Button';
import WhatsAppFloatingButton from '../components/layout/WhatsAppFloatingButton';
import { practiceAreas } from '../data/practiceAreas';
import { teamMembers } from '../data/teamMembers';

// Import local slider images
import slider1 from '../assets/heroslider1.png';
import slider2 from '../assets/heroslider2.png';
import slider3 from '../assets/heroslider3.png';

import client1 from '../assets/client1.png';
import client2 from '../assets/client2.png';
import client3 from '../assets/client3.png';
import client4 from '../assets/client4.png';
import client5 from '../assets/client5.png';
import client6 from '../assets/client6.png';

// Hero Slides Data
const slides = [
  {
    id: 1,
    title: "Family Law",
    headline: "Expert Legal Support for Family Matters",
    description: "Compassionate guidance through divorce, child custody, alimony, and domestic violence cases.",
    button: "Consult with Adv. Pintu",
    link: "/practices/family-matters",
    bgImage: slider1
  },
  {
    id: 2,
    title: "Civil Litigation",
    headline: "Protecting Your Assets and Civil Rights",
    description: "Specialized handling of property disputes, money recovery, cheque bounce cases, and consumer protection.",
    button: "Secure Your Property",
    link: "/practices/civil-matters",
    bgImage: slider2
  },
  {
    id: 3,
    title: "Criminal Defense",
    headline: "Strong Legal Defense and Representation",
    description: "Dedicated legal advocacy for criminal matters, including bail applications and court hearings.",
    button: "Get Immediate Assistance",
    link: "/practices/criminal-matters",
    bgImage: slider3
  }
];

// Clients/Clientele Data
const clients = [
  { name: "Client 1", logo: client1 },
  { name: "Client 2", logo: client2 },
  { name: "Client 3", logo: client3 },
  { name: "Client 4", logo: client4 },
  { name: "Client 5", logo: client5 },
  { name: "Client 6", logo: client6 }
];

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Slider Section */}
      <HeroSlider slides={slides} />

      {/* About Section with Inquiry Form */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* Left Column - About Content */}
            <div>
              <SectionTitle
                subtitle="About Us"
                title="Where Justice Meets Compassion"
                alignment="left"
                showLine={true}
              />
              
              <p className="text-dark-gray text-lg mb-6 leading-relaxed">
                Since 2016, <span className="font-semibold text-primary-blue">AKY Legal Consultants</span> has operated under the guiding principle: 
                <span className="text-gold font-semibold"> "Where Justice Meets Compassion."</span> Based in Mumbai, our firm provides 
                sophisticated legal counsel across the Bombay High Court and various judicial forums.
              </p>
              
              <p className="text-dark-gray text-lg mb-8 leading-relaxed">
                Led by <span className="font-semibold text-primary-blue">Adv. Pintu Arjun Yadav</span> (M.COM, BBI, LL.B), we combine financial literacy 
                with rigorous legal expertise to deliver results that are both legally sound and strategically viable.
              </p>
              
              <Button
                to="/about/firm"
                variant="primary"
                size="lg"
                icon={ArrowRight}
                iconPosition="right"
              >
                Learn More About Us
              </Button>
            </div>

            {/* Right Column - Inquiry Form */}
            <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8">
              <h3 className="text-2xl font-bold text-primary-blue mb-6 text-center">
                Free Consultation
              </h3>
              <InquiryForm />
            </div>
          </div>
        </div>
      </section>

      {/* Practice Areas Section */}
      <section className="py-20 bg-primary-blue">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionTitle
            subtitle="Our Expertise"
            title="Our Practice Areas"
            alignment="center"
            titleColor="white"
            showLine={true}
          />
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
            {practiceAreas.map((area, index) => (
              <PracticeAreaCard key={index} area={area} />
            ))}
          </div>
        </div>
      </section>

      {/* Leadership Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionTitle
            subtitle="Our Team"
            title="Our Leadership"
            alignment="center"
            showLine={true}
          />
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto mt-12">
            {teamMembers.slice(0, 3).map((member, index) => (
              <LeadershipCard key={index} member={member} />
            ))}
          </div>

          {/* View All Team Button */}
          <div className="text-center mt-12">
            <Button
              to="/about/leadership"
              variant="outline"
              size="lg"
              icon={ArrowRight}
              iconPosition="right"
            >
              Visit Team Page
            </Button>
          </div>
        </div>
      </section>

      {/* Our Clientele Section */}
      {/* <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionTitle
            subtitle="Trusted By"
            title="Our Clientele"
            alignment="center"
            showLine={true}
          />
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mt-12">
            {clients.map((client, index) => (
              <ClientLogo key={index} client={client} />
            ))}
          </div>

        </div>
      </section> */}

      {/* Call to Action Section */}
      <CTASection />

      {/* Floating WhatsApp Button */}
      <WhatsAppFloatingButton />
    </div>
  );
};

export default Home;
